import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../../common/Popup';
import RemoveInvitationLinkForm from '../RemoveInvitationLinkForm';
import styles from './styles.styl';

const RemoveInvitationLinkPopup = ({ opened, onClose, email }) => {
  return (
    <Popup
      opened={opened}
      className={styles.cancelPopup}
      white
      onClose={onClose}
    >
      <RemoveInvitationLinkForm close={onClose} email={email} />
    </Popup>
  );
};

RemoveInvitationLinkPopup.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  email: PropTypes.string,
};

export default RemoveInvitationLinkPopup;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/RemoveInvitationLinkPopup/index.jsx